import moment from 'moment'
import { IActiveTaskFragment } from '../graphql/ActiveTaskFragment'

/**
 * From a list of tasks, returns the task with the earliest due date that is not already completed or expired.
 */
export const getNextTask = (tasks: IActiveTaskFragment[] | undefined): IActiveTaskFragment => {
  if (!tasks?.length) return {} as IActiveTaskFragment
  return tasks.reduce((nextTask, currentTask) => {
    const isCompleted = currentTask.completedAt
    const isExpired = currentTask.expiresAt && moment(currentTask.expiresAt).isBefore(moment())
    const isActive = !isCompleted && !isExpired
    if (!isActive) return nextTask
    if (!nextTask.id) {
      return currentTask
    }
    const hasEarlierDueDate = moment(currentTask.dueAt).isBefore(moment(nextTask.dueAt))
    if (hasEarlierDueDate) return currentTask
    return nextTask
  }, {} as IActiveTaskFragment)
}
